import login from './chinese/login.json'
import registration from './chinese/registration.json'
import dashboard from './chinese/dashboard.json'
import addJob from './chinese/add-job.json'
import validations from './chinese/validations.json'
import jobDetails from './chinese/job-details.json'
import notifications from './chinese/notifications.json'
import jobListItem from './chinese/job-list-item.json'
import inviteWorkers from './chinese/invite-workers.json'
import navigation from './chinese/navigation.json'
import favorites from './chinese/favorites.json'
import transactions from './chinese/transactions.json'
import referrals from './chinese/referrals.json'
import settings from './chinese/settings.json'
import jobSearch from './chinese/job-search.json'

const CH = {
  'login': login,
  'registration': registration,
  'dashboard': dashboard,
  'addJob': addJob,
  'validations': validations,
  'jobDetails': jobDetails,
  'notifications': notifications,
  'jobListItem': jobListItem,
  'inviteWorkers': inviteWorkers,
  'navigation': navigation,
  'favorites': favorites,
  'transactions': transactions,
  'referrals': referrals,
  'settings': settings,
  'jobSearch': jobSearch
}

export default CH
